import { personalDataClient } from 'servicesCommon/client';
import { AxiosTypedPromise, SuccessResponse } from 'servicesCommon/apiTypes';
import {
	CreditCardsResponse,
	SingleCreditCardResponse,
	GetBookingCardRequest,
	AddCreditCardToBookingRequest,
	AddOneTimeCardToBookingRequest,
} from './CreditCardsTypes';
import {
	GetCreditCardInfoRequest,
	GetCreditCardInfoResponse,
	CreateStripeSessionResponse,
} from 'app-types';
import { urlFormatter } from 'utils/utils';

const ccUrl = urlFormatter('/credit-cards');
export const creditCardsApi = {
	createStripeSession(): AxiosTypedPromise<CreateStripeSessionResponse> {
		return personalDataClient.post(ccUrl('create-stripe-setup-intent'));
	},
	getCreditCardInfo(
		data: GetCreditCardInfoRequest
	): AxiosTypedPromise<GetCreditCardInfoResponse> {
		return personalDataClient.get(ccUrl('get-credit-card-info', data));
	},

	getCardsForBooking(): AxiosTypedPromise<CreditCardsResponse> {
		return personalDataClient.get(ccUrl('get-customer-user-credit-cards-for-booking'));
	},
	getBookingCard(data: GetBookingCardRequest): AxiosTypedPromise<SingleCreditCardResponse> {
		return personalDataClient.get(ccUrl('get-booking-credit-card', data));
	},

	addCreditCardToBooking(
		data: AddCreditCardToBookingRequest
	): AxiosTypedPromise<SuccessResponse> {
		return personalDataClient.post(ccUrl('add-customer-user-credit-card-to-booking'), data);
	},

	addOnetimeCardToBooking(
		data: AddOneTimeCardToBookingRequest
	): AxiosTypedPromise<SuccessResponse> {
		return personalDataClient.post(ccUrl('add-onetime-credit-card-to-booking'), data);
	},
};
